module.exports = "/legacy/4906c2f6dbad121e481e21a19838818b.svg";